exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit__form {\n  width: 100%; }\n\n.beta__tag {\n  background: #2d235f;\n  border-radius: 43px;\n  font-family: 'Basier Circle';\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.20000000298023224px;\n  text-align: center;\n  padding: 2px 8px;\n  height: 20px;\n  color: white;\n  margin-bottom: 3px; }\n\n.panel__content {\n  padding-top: 60px; }\n\n.panel__title {\n  line-height: 32px;\n  margin: 0px !important; }\n\n.title__row {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: flex-end;\n  margin-top: 30px;\n  line-height: 32px; }\n\n.top__bar {\n  margin-bottom: 20px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Dashboard/Panels/Client/index.scss
// module id = 6322
// module chunks = 1